import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Signin = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardInit`);
			const params = {
				id: auth.id ? auth.id : "",
				type: auth.type ? auth.type : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setAlert({});
					history.push(`/dashboard/${json.dashId}`);
				} else {
					setAlert({});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardSignin`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("email", "");
				formElement.current.email.value = "";
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Dashboard" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>!</h1>
							<div>
								<p>
									If you are the main contact on a completed sponsor
									registration (but maybe have lost your access code), please
									enter the email address we have on file for your registration
									and we will send you an access link.
								</p>

								<p>
									Questions? Please call Samantha Murray at 210-345-5279 or
									email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<h3 style={{ marginTop: "25px", marginBottom: "25px" }}>
							Request Access Link
						</h3>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Please enter the main contact email address for your sponsor
								registration:
							</h4>

							<div className="form-group">
								<Input
									name="email"
									label="Email Address"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>

								<div className="empty" />
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Submit Request" />
								</div>
							</div>
						</form>
					</div>

					<div id="right-column"></div>
				</>
			)}
		</>
	);
};

export default Signin;
